import { render, staticRenderFns } from "./Incentive.vue?vue&type=template&id=4b5012d0&"
import script from "./Incentive.vue?vue&type=script&lang=js&"
export * from "./Incentive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports